import { Code as MantineCode } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./code.module.scss";
import type { CustomCodeFactory, IProps } from "./code.types";

/**
 * Code component for displaying inline or block code snippets in a monospace font.
 * @param {string} props.variant - Visual variant: "default" keeps Mantine's look, "solid" renders a black block in both
 * colour schemes.
 * @param {boolean} props.block - When true, the code is rendered in a `pre` element.
 * @returns {JSX.Element} The Code component.
 */
const Code = componentWrapper<CustomCodeFactory, IProps>("Code", ({ variant = "default", ...props }, ref) => {
    return <MantineCode ref={ref} variant={variant} classNames={{ root: styles["root"] }} {...props} />;
});

export { Code };
